export default __webpack_public_path__ + "static/media/youtube.eab4f148.svg";